import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';
import { useMountEffect } from '@/hooks/useMountEffect.ts';

type AntdModalInstance = Omit<ModalStaticFunctions, 'warn'>;

export let message: MessageInstance;
export let notification: NotificationInstance;
export let modal: AntdModalInstance;

export const AntdAppFeedbackBridge = () => {
  const staticFunction = App.useApp();

  useMountEffect(() => {
    message = staticFunction.message;
    modal = staticFunction.modal;
    notification = staticFunction.notification;
  });

  return null;
};
